import React from 'react';
import {Col, Row} from 'reactstrap';
import Menu from "../../components/menu-flower/menu";
import Button from "../../components/menu-flower/button";

import ResizeObserver from "resize-observer-polyfill";
import {AnimatePresence} from "framer-motion";
import {ToggleLayer} from "react-laag";

import {mainService} from "../../jwt/_services";
import {showLoader} from "../../components/loader/loader";

class Modules extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            modules: [],
            loading : false
        }

        this.handlerClick = this.handlerClick.bind(this);
    }

    componentDidMount() {
        this.setState({ loading: true });
        mainService.getModules()
            .then(modules => {
                if (modules){
                    this.setState({ modules: modules, loading : false });
                    this.setModule(modules);
                } else {
                    this.setState({ modules: [], loading : false });
                    this.setModule([]);
                }

            }).catch(_ => {
            this.setState({ modules: [], loading : false });
            this.setModule([]);
        });
    }

    setModule(categoryModules){
        if (categoryModules){
            categoryModules.map((cm) => {
                if (cm['General'] !== undefined && cm['General'] !== null) {
                    cm['General'].map((module) => {
                        if (module && module.code === 'PROFILE') {
                            localStorage.setItem('profileModule', JSON.stringify(module));
                        }
                    });

                }
            })
            // if ( categoryModules['General'] !== undefined ){
            //     categoryModules['General'].map((module) => {
            //         if (module && module.code === 'PROFILE') {
            //             localStorage.setItem('profileModule', JSON.stringify(module));
            //         }
            //     });
            // }
        }
    }

    getItems(udns) {
        if (udns === '') {
            return udns;
        }
        this.state.udns = udns;
        let udn;
        const data = [];
        for (let i=0; i<udns.length; i++) {
            udn = udns[i];
            data.push({
                Icon: udn.iconXkynet,
                value: udn.name,
                id : udn.id,
                label: udn.name,
                code: udn.code,
                color: udn.color,
                style: {backgroundColor: udn.color}
            });
        }
        return data;
    }

    handlerClick(extraData) {
        this.setState({loading: true});
        mainService.blankOnClickModules(extraData).then(_ => {
        });
    }

    render() {
        if (this.state.modules === '') return null;
        return (
            <div key={'modules'}>
                { this.state.loading && showLoader()}
                {
                    Object.entries(this.state.modules).map(([sectionKey, data]) => {
                        let response = [];
                        Object.entries(data).map( ([sectionName, section]) => {
                            let columns = [];
                            response.push(<div className="p-4"  key={sectionName}>
                                <span className="font-bold title-white">{sectionName}</span>
                            </div>);

                            Object.entries(section).map(([key, module]) => {
                                columns.push
                                (<Col sm="2" md="4" xl="2" className="col-xlg-" text="center" key={`${key}-${sectionName}-COL`}>
                                    <center>
                                        <div >
                                            <ToggleLayer
                                                ResizeObserver={ResizeObserver}
                                                placement={{
                                                    anchor: "CENTER"
                                                }}
                                                renderLayer={({ isOpen, layerProps, close }) => {
                                                    return (
                                                        <AnimatePresence>
                                                            {isOpen && (
                                                                <Menu
                                                                    {...layerProps}
                                                                    close={close}
                                                                    items={this.getItems(module.udns)}
                                                                    extraData={{
                                                                        module: module,
                                                                        udns: module.udns
                                                                    }}
                                                                />
                                                            )}
                                                        </AnimatePresence>
                                                    );
                                                }}
                                            >
                                                {({ triggerRef, toggle, isOpen }) => (
                                                    <Button
                                                        style={{backgroundColor: "linear-gradient(359.5deg, #F2F7FD 5.07%, #FFFFFF 95.22%)"}}
                                                        className={"justify-content-center"}
                                                        icon={module.icon}
                                                        name={module.name}
                                                        ref={triggerRef}
                                                        onClick={module.udns != '' ? toggle : () => {
                                                            this.handlerClick({
                                                                module: module,
                                                                udns: module.udns
                                                            })
                                                        }}
                                                        isOpen={isOpen} />
                                                )}
                                            </ToggleLayer>
                                        </div>
                                    </center>
                                </Col>);

                                if ((parseFloat(key) + 1) % 5 === 0 || (parseFloat(key) + 1) === (section.length)) {
                                    response.push(<div key={`${key}-${sectionName}-ROW`}><Row className="justify-content-md-center">{columns}</Row><br/>, <br/></div>);
                                    columns = [];
                                }
                            });
                        })
                        return response
                    })
                }
            </div>
        );
    }
}

export default Modules;